<template>
	<div v-title title="我的订单" class="order-list-page">
		<van-tabs @click="changeTab" v-model="searchForm.status" sticky :offset-top="0" color="#00754A" line-width="10px">
			<van-tab title="全部" name=""></van-tab>
			<van-tab title="待付款" name="0"></van-tab>
			<van-tab title="待发货" name="2"></van-tab>
			<van-tab title="待收货" name="3"></van-tab>
			<van-tab title="待评价" name="8"></van-tab>
		</van-tabs>
		<div class="no-more" v-if="!list || !list.length">
			<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
			<span class="tips" v-if="searchForm.status == 8">抱歉，没有更多评价呢～</span>
			<span class="tips" v-else>抱歉，暂无订单呢～</span>
		</div>

		<van-list v-else class="list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="queryList">
			<div @click="goToDetail(item)" class="order-item" v-for="item in list" :key="item.id">
				<div class="line-1 flex">
					<img class="icon" src="@/assets/images/order/icon_shop.png" alt="" />
					<span class="title">{{ shop.invoiceProvideCompany }}</span>
					<span class="flex1"></span>
					<div v-if="item.status == '0' || item.status == '1'" class="bg-red">
						<van-count-down class="down" :time="item.minute" format="mm 分 ss 秒" />
						<span class="btn">待付款</span>
					</div>
					<span class="text-red" v-if="item.status == '2'">待发货</span>
					<span class="text-red" v-if="item.status == '3'">待收货</span>
					<span class="text-grey" v-if="item.status == '5'">已取消</span>
				</div>
				<div class="line-2 flex">
					<img class="img" :src="item.orderItemList[0].productPic" alt="" />
					<div class="title-g">
						<div class="title">
							{{ item.orderItemList[0].productName }}
						</div>
						<!-- <div class="g">
							安徒生剪纸系列天鹅与芭蕾舞列天鹅与芭蕾舞列天鹅与芭蕾舞
						</div> -->
					</div>
					<span class="flex1"></span>
					<div class="price-box">
						<span class="price">¥{{ item.orderItemList[0].productPrice }}</span>
						<span class="price-num">x{{ item.orderItemList[0].productQuantity }}</span>
					</div>
				</div>
				<div class="line-3">
					<span class="text f13">{{ item.status != 0 && item.status != 1 && item.status != 5 ? '实付款' : '需付款' }}</span>
					<span class="text f10">￥</span>
					<span class="text f16" v-if="item.status == 0 || item.status == 1">{{ item.payAmount | price }}</span>
					<span class="text f16" v-else-if="item.status == 5">{{ item.payAmount - item.channelRpktRducAmt -
			item.channelPntDsctAmt |
			price }}</span>
					<span class="text f16" v-else>{{ item.channelPayAmt | price }}</span>
					<!-- <span class="text f14">.{{ item.payAmount | price }}</span> -->
					<!-- <section v-if="item.status == 0 || item.status == 1">
						<span class="text f10">￥</span>
						<span class="text f16">{{ (item.payAmount | price).split('.')[0] }}</span>
						<span class="text f14">.{{ (item.payAmount | price).split('.')[1] }}</span>
					</section>
					<section v-else-if="item.status == 5">
						<span class="text f10">￥</span>
						<span class="text f16">{{ (item.payAmount - item.channelRpktRducAmt - item.channelPntDsctAmt |
							price).split('.')[0] }}</span>
						<span class="text f14">.{{ (item.payAmount - item.channelRpktRducAmt - item.channelPntDsctAmt |
							price).split('.')[1] }}</span>
					</section>
					<section v-else>
						<span class="text f10">￥</span>
						<span class="text f16">{{ (item.channelPayAmt | price).split('.')[0] }}</span>
						<span class="text f14">.{{ (item.channelPayAmt | price).split('.')[1] }}</span>
					</section> -->
				</div>
				<div class="line-4" v-if="(item.status == 0 || item.status == 1) ||
			((item.status == 3 || item.status == 4) && item.deliveryType == 1) ||
			(item.status == 4 && item.isComment == 0 && item.isReturn == 0) ||
			((item.status == 0 || item.status == 1) && item.showPay) ||
			(item.status == 3 && item.isReturn == 0)
			">
					<div class="btn" v-if="item.status == 0 || item.status == 1" @click.stop="cancelOrder(item.id)">取消订单</div>
					<div class="btn" v-if="(item.status == 3 || item.status == 4) && item.deliveryType == 1"
						@click.stop="queryTrackList(item)">查看物流</div>
					<div class="btn gren" v-if="item.status == 4 && item.isComment == 0 && item.isReturn == 0"
						@click.stop="pingjia(item)">立即评价</div>
					<div class="btn gren" @click.stop="payNow(item)"
						v-if="(item.status == 0 || item.status == 1) && item.showPay">
						立即支付</div>
					<div class="btn gren" v-if="item.status == 3 && item.isReturn == 0" @click.stop="confirmReceive(item)">确认收货
					</div>
				</div>
			</div>
		</van-list>


		<van-popup closeable close-icon="close" style="width: 90vw;max-height: 80vh;overflow-y: auto"
			v-model="trackListShow">
			<div style="padding: 2vh;background: #ffffff;position: relative">
				<div class="width100 font-pain-grey font15rem" style="padding-bottom: 1vh">
					{{ deliveryCompany }} {{ deliverySn }}
				</div>

				<van-steps active-color="#38f" direction="vertical" :active="0">
					<van-step v-for="item in trackList" :key="item.id">
						<div class="font2rem">{{ item.statusDesc }}</div>
						<div class="font-pain-grey" style="padding-top: 1vh">
							{{ item.nodeTimeFmt }}
						</div>
						<div class="font-pain-grey" style="padding-top: 1vh">{{ item.nodeContext }}</div>
					</van-step>
				</van-steps>
			</div>
		</van-popup>
		<div style="height: 10vh"></div>
		<MyDialog :dialogForm="dialogForm" />

		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/orderList"></div>
	</div>
</template>

<script>
import { post } from 'api/post'
import { get } from 'api/get'
import { Toast } from 'vant';
import Empty from '@/assets/images/empty.jpg'
import MyDialog from '@/components/MyDialog.vue'
export default {
	name: "Order",
	components: {
		MyDialog,
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			empty: Empty,
			loading: false,
			finished: false,
			value: '',
			searchForm: {
				pageNum: 1,
				pageSize: '',
				status: ''
			},
			list: [],
			receiveShow: false,
			time: 60 * 60 * 1000,
			trackListShow: false,
			deliveryCompany: '',
			deliverySn: '',
			trackList: [],
			shop: {
				name: '',
				logo: '',
				invoiceProvideCompany: '',
				customerServicePhone: '',
				customerServiceTime: '',
				onlineServiceTime: '',
				businessLicense: ''
			},
		};
	},
	created() {

		if (this.$route.query.status !== undefined) {
			this.searchForm.status = this.$route.query.status
		}
		this.queryList()
		this.getShopDetail()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		submit() {

		},
		onClickLeft() {
			this.$router.push("/user");
		},
		goToDetail(item) {
			this.$router.push({
				path: '/orderDetail',
				query: {
					orderId: item.id,
					status: item.status.toString(),
				}
			})
		},
		changeTab() {
			this.searchForm.pageNum = 1
			this.list = []

			this.queryList()
		},
		changeAddress(id) {
			this.$router.push({
				path: '/orderAddress',
				query: {
					orderId: id,
				}
			})
		},
		cancelOrder(id) {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否取消该订单？',
				contentTips: '',
				btnCancelText: '暂不取消',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					get('order/cancelOrder/' + id, {}).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast(res.message);
							self.searchForm.pageNum = 1
							self.list = []
							self.queryList()
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A'
							})
						}
					})
				}
			}
		},
		pingjia(item) {
			this.$router.push({
				path: '/pingjia',
				query: {
					orderId: item.id,
					productId: item.orderItemList[0].productId,
					productName: item.orderItemList[0].productName,
					productAttr: item.orderItemList[0].productAttr,
				}
			})
		},
		queryList() {

			let self = this
			get('order/list', this.searchForm).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					// this.list.concat(res.data.list)

					this.list = this.list.concat(res.data.list);




					for (let i in this.list) {
						if (this.list[i].status === 0 || this.list[i].status === 1) {
							let d1 = new Date(this.list[i].expiryTime);//已知时间戳
							let d2 = new Date();//当前时间戳
							let minute = parseInt(d1 - d2)

							this.list[i].minute = minute
							if (minute > 0) {
								this.list[i].showPay = true
							}

							setTimeout(function () {
								self.$set(self.list[i], 'showPay', false)
							}, this.list[i].minute)
						}
					}

					if (this.list.length >= res.data.total) {
						this.finished = true;
					} else {
						this.finished = false
						this.searchForm.pageNum = this.searchForm.pageNum + 1
					}

				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A'
					})
				}
			}).finally(() => {
				this.loading = false;
			})
		},
		confirmReceive(item) {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否确认收货？',
				contentTips: '',
				btnCancelText: '暂不收货',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					this.$get('order/confirmReceiveOrder/' + item.id, {}).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast('确认收货成功');
							self.searchForm.pageNum = 1
							self.list = []
							self.queryList()
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A'
							})
						}
					})
				}
			}
		},
		payNow(item) {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否立即支付？',
				contentTips: '',
				btnCancelText: '暂不支付',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					Toast.loading({
						forbidClick: true,
						loadingType: 'spinner',
					});
					this.$get('order/payment/' + item.id, {}).then((res) => {
						console.log(res)

						if (res.code === this.GLOBAL.SUCCESS) {
							if (!res.data.success) {
								window.location.href = res.data.paymentPageUrl
							} else {
								self.$toast(res.message);
							}
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A'
							})
						}
					}).finally(() => {
						Toast.clear();
					})
				}
			}
		},
		queryTrackList(item) {


			this.$router.push({
				path: '/wuliuDetail',
				query: {
					orderId: item.id,
					fromPage: 'orderList',
					status: this.searchForm.status,
				}
			})

			// this.deliveryCompany = item.deliveryCompany
			// this.deliverySn = item.deliverySn
			// this.$get('order/trackList/' + item.id, {}).then((res) => {
			//     console.log(res)
			//     if (res.code === this.GLOBAL.SUCCESS) {
			//
			//         this.trackListShow = true
			//         this.trackList = res.data
			//         this.trackList.forEach(item => {
			//             let d = new Date(item.nodeTime)
			//             item.nodeTimeFmt = this.parseTime(d)
			//         })
			//     } else {
			//         this.$dialog.alert({
			//             theme: 'round-button',
			//             message: res.message,
			//             confirmButtonColor: '#00754A'
			//         })
			//     }
			// })
		},
		getShopDetail() {
			let self = this
			this.$get('setting/sysParam/sys_shop_param').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					self.shop.invoiceProvideCompany = resData.find(i => i.dictLabel == '发票提供公司').dictValue
					self.shop.customerServicePhone = resData.find(i => i.dictLabel == '商城客服电话').dictValue
					self.shop.customerServiceTime = resData.find(i => i.dictLabel == '商城服务时间').dictValue
					self.shop.date = resData.find(i => i.dictLabel == '商城服务日期').dictValue
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a'
					})
				}
			})
		},
		parseTime(time, pattern) {
			if (arguments.length === 0 || !time) {
				return null
			}
			const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
			let date
			if (typeof time === 'object') {
				date = time
			} else {
				if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
					time = parseInt(time)
				} else if (typeof time === 'string') {
					time = time.replace(new RegExp(/-/gm), '/');
				}
				if ((typeof time === 'number') && (time.toString().length === 10)) {
					time = time * 1000
				}
				date = new Date(time)
			}
			const formatObj = {
				y: date.getFullYear(),
				m: date.getMonth() + 1,
				d: date.getDate(),
				h: date.getHours(),
				i: date.getMinutes(),
				s: date.getSeconds(),
				a: date.getDay()
			}
			const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
				let value = formatObj[key]
				// Note: getDay() returns 0 on Sunday
				if (key === 'a') {
					return ['日', '一', '二', '三', '四', '五', '六'][value]
				}
				if (result.length > 0 && value < 10) {
					value = '0' + value
				}
				return value || 0
			})
			return time_str
		}

	},
}
</script>


<style scoped lang="less">
/deep/.van-tabs__line {
	bottom: 20px;
}

.order-list-page {
	min-height: 100vh;
	background: #F7F7F7;

	.no-more {
		margin: 140px auto 0;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.img {
			width: 110px;
			height: 100px;
		}

		.tips {
			margin-top: 8px;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 14px;
		}
	}

	.list {
		max-height: calc(100vh - 54px);
		position: relative;
		overflow: auto;

		.order-item {
			box-sizing: border-box;
			margin: 10px auto;
			padding: 8px 12px 12px;
			width: 355px;
			background: #FFFFFF;
			border-radius: 10px;

			.flex {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: center;
				align-items: center;

				.flex1 {
					flex: 1;
				}
			}

			.line-1 {
				height: 22px;

				.icon {
					width: 14px;
					height: 14px;
					margin-right: 4px;
				}

				.title {
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #666666;
					line-height: 14px;
				}

				.bg-red {
					background: rgba(255, 78, 78, 0.06);
					border-radius: 11px;
					display: flex;
					flex-direction: row;
					flex-wrap: nowrap;
					align-content: center;
					justify-content: center;
					align-items: center;

					.down {
						box-sizing: border-box;
						height: 22px;
						line-height: 14px;
						padding: 4px 8px;
						// background: rgba(255, 78, 78, 0.06);
						border-radius: 11px;
						font-size: 11px;
						color: #FF4E4E;
					}

					.btn {
						width: 49px;
						height: 22px;
						background: #FF4E4E;
						border-radius: 11px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 11px;
						color: #FFFFFF;
						line-height: 22px;
						text-align: center;
					}
				}




				.text-red {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #FF4E4E;
					line-height: 16px;
				}

				.text-grey {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
					line-height: 16px;
				}
			}

			.line-2 {
				margin: 8px 0 0;
				height: 70px;
				align-items: flex-start;

				.img {
					width: 70px;
					height: 70px;
					border-radius: 6px;
				}

				.title-g {
					margin: 2px 0 0 12px;
					display: flex;
					flex-direction: column;

					.title {
						width: 169px;
						height: 36px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
					}

					.g {
						width: 169px;
						height: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 11px;
						color: #999999;
						line-height: 14px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;

					}
				}

				.price-box {
					margin-top: 5px;
					display: flex;
					flex-direction: column;

					.price {
						height: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #333333;
						line-height: 14px;
						text-align: right;
						font-style: normal;
					}

					.price-num {
						margin-top: 4px;
						height: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #333333;
						line-height: 14px;
						text-align: right;
					}
				}
			}

			.line-3 {
				margin-top: 6px;
				height: 16px;
				text-align: right;
				font-size: 0;

				.text {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
					line-height: 16px;
				}

				.f10 {
					font-size: 10px;
				}

				.f13 {
					font-size: 13px;
				}

				.f14 {
					font-size: 14px;
				}

				.f16 {
					font-size: 16px;
				}
			}

			.line-4 {
				margin-top: 16px;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: flex-end;
				align-items: center;

				.btn {
					margin-left: 10px;
					width: 80px;
					height: 34px;
					border-radius: 8px;
					border: 1px solid #CCCCCC;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #333333;
					line-height: 34px;
					text-align: center;
				}

				.gren {
					background: #00754A;
					color: #FFFFFF;
					border: none;
					font-weight: 500;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/order/index.vue